'use client';
import { TSearchEventTracks } from '@/apis/s/s.interface';
import CartIcon from '@/assets/icons/cart.svg';
import pageSDK from '@/utils/goToPage';
import cn from 'clsx';
import { useEffect, useState } from 'react';
import styles from './index.module.scss';
import { observer } from 'mobx-react-lite';
import { useStores } from '@/models';

interface SliderBarProps {
  onBackToTop: Function;
  showCart: boolean;
  showBackToTop: boolean;
  searchEventTrack: TSearchEventTracks;
  k?: string;
  frontCategoryId?: string;
  logid?: string;
  storeId?: string;
}

export default observer(function SideBar({
  onBackToTop,
  showBackToTop,
  showCart,
  k,
  frontCategoryId,
  logid,
  storeId,
  searchEventTrack,
}: SliderBarProps) {
  const { cartNumStore } = useStores();
  const { displayCartNum, isCartNumValid } = cartNumStore;

  useEffect(() => {
    cartNumStore.fetchCartNum();
  });

  const onCart = () => {
    pageSDK.goToPage({
      jumpType: 'fun',
      jumpValue: {
        obj: {
          urlJumpTerminalList: [
            {
              terminal: 5,
              jumpCode: 'cart',
            },
          ],
        },
      },
    });
  };
  return (
    <div className={styles.sideBar}>
      <div className={cn(styles.icon, !showCart && styles.hide)}>
        <CartIcon onClick={onCart}></CartIcon>
        {isCartNumValid ? <span className={styles.num}>{displayCartNum}</span> : null}
      </div>
      {/* 设计要求暂时去掉回到顶部按钮 */}
      {/* <div
        className={cn(styles.icon, !showBackToTop && styles.hide)}
        data-exptag-config='{"useClick": false, "stay_duration": 0, "repeated":false, "area_rate": 0.01}'
        data-exp={JSON.stringify({
          spm: 'a0146.b002226.c00002385.BacktoTop',
          biz_type: '',
          event_id: 'Search_ProductList_BacktoTop_Expo',
          json_param:JSON.stringify({
          keyWord: k,
          categoryId: frontCategoryId || "-100",
          pvid: logid,
          mtest: "",
          channelName: "Search_result",
          shopid: storeId || "-100",
          ...searchEventTrack
        }),
      })}
      >
        <ToTopIcon onClick={onBackToTop}></ToTopIcon>
      </div> */}
    </div>
  );
});
